<div id="evmap" [class.select-any-estate]="selectAnyEstateActive()"></div>
<app-base-page></app-base-page>
<div class="mobile-header"></div>
<map-mode-buttons (openWeb40)="openWeb40($event)"></map-mode-buttons>
<map-navigation-tools></map-navigation-tools>

<div class="router-wrapper">
    <router-outlet></router-outlet>
</div>
